import styled from 'styled-components';

interface ThProps {
    width?: string;
}

export const Th = styled.th<ThProps>`
    ${(props) => (props.width ? `width: ${props.width};` : null)}
`;
